import { isDefined } from "@utils/helpers";

import { Tracking } from "../types/tracking.types";

export type TrackingProperties = {
    "data-tracking-event": string;
    "data-tracking-info": string;
};

export const createTrackingProperties = (
    trackingType: "click" | "impression",
    tracking?: Tracking,
): TrackingProperties | undefined => {
    if (!isDefined(tracking)) return;

    const { clickEvent, impressionEvent, info } = tracking;

    return trackingType === "click"
        ? {
              "data-tracking-event": clickEvent,
              "data-tracking-info": info,
          }
        : {
              "data-tracking-event": impressionEvent,
              "data-tracking-info": info,
          };
};
